import React from 'react';
import { useTranslation } from 'react-i18next';
import Home from '../../../Icons/Home';
import GroupsList from '../GroupsList';
import s from './DesktopLayout.scss';
export var DesktopGroupsList = function (_a) {
    var onGroupSelected = _a.onGroupSelected;
    var t = useTranslation().t;
    var header = (React.createElement("div", { className: s['header'] },
        t('addToGroup.addToGroups'),
        React.createElement(Home, { className: s['group-icon'] }),
        React.createElement("span", { className: s['hint'] }, t('addToGroup.chooseAnyGroup'))));
    return (React.createElement(GroupsList, { headerContent: header, onGroupSelected: onGroupSelected }));
};
DesktopGroupsList.displayName = 'DesktopGroupsList';
export default DesktopGroupsList;
//# sourceMappingURL=DesktopGroupsList.js.map